import { Modal } from "antd";
import React from "react";
import "./BIDModal.css";

export default function BIDModal({ title, visible, onCancel, children }) {
  return (
    <Modal title={title} visible={visible} onCancel={onCancel} footer={null}>
      {children}
    </Modal>
  );
}
